<template>
    <el-dialog
        :title="title"
        width="1000px"
        top="5vh"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        class="algorithm-parameters"
    >
        <div v-loading="loadings">
            <el-row
                v-if="type === 'searchEdit'"
                :gutter="20"
                class="search-title"
            >
                <el-col :span="6">
                    <advance-dialog
                        v-model="siteName"
                        :mValue="siteName"
                        :params="config.siteParams"
                        @getAdvanceValue="getAdvance"
                    >
                    </advance-dialog>
                </el-col>
                <el-col :span="3">
                    <el-button type="primary" @click="handleSearch"
                        >查 询</el-button
                    >
                </el-col>
            </el-row>
            <el-form
                ref="ruleForm"
                :model="form"
                :rules="config.rules"
                class="algorithm-from"
                label-width="130px"
            >
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="服务平台" prop="siteName">
                            <advance-dialog
                                v-model="form.siteName"
                                :disabled="type !== 'add'"
                                :mValue="form.siteName"
                                :params="config.siteParams"
                                @getAdvanceValue="getAdvanceSiteNameValue"
                            >
                            </advance-dialog>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="串点集中度" prop="inDistanceValue">
                            <el-input
                                v-model.number="form.inDistanceValue"
                                clearable
                                :disabled="
                                    type === 'check' || type === 'searchEdit'
                                "
                                maxlength="10"
                                oninput="if(isNaN(value)){value = null}"
                                placeholder="请输入串点集中度"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="加速参数(0~1)" prop="accValue">
                            <el-input
                                v-model.trim="form.accValue"
                                clearable
                                :disabled="
                                    type === 'check' || type === 'searchEdit'
                                "
                                maxlength="10"
                                oninput="if(isNaN(value)){value = null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+2)} if(value > 1){
                            value = null}"
                                placeholder="请输入加速参数"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="最大串点数量" prop="slackNValue">
                            <el-input
                                v-model.number="form.slackNValue"
                                clearable
                                :disabled="
                                    type === 'check' || type === 'searchEdit'
                                "
                                maxlength="10"
                                oninput="if(isNaN(value)){value = null}"
                                placeholder="请输入最大串点数量"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="线路距离上限" prop="slackDValue">
                            <el-input
                                v-model.number="form.slackDValue"
                                clearable
                                :disabled="
                                    type === 'check' || type === 'searchEdit'
                                "
                                maxlength="10"
                                oninput="if(isNaN(value)){value = null}"
                                placeholder="请输入线路距离上限"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="线路最长用时"
                            prop="maxRouteTimeValue"
                        >
                            <el-input
                                v-model.trim="form.maxRouteTimeValue"
                                clearable
                                :disabled="
                                    type === 'check' || type === 'searchEdit'
                                "
                                maxlength="10"
                                oninput="if(isNaN(value)){value = null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                                placeholder="请输入线路最长用时"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="每小时装卸点数" prop="efValue">
                            <el-input
                                v-model.trim="form.efValue"
                                clearable
                                :disabled="
                                    type === 'check' || type === 'searchEdit'
                                "
                                maxlength="10"
                                oninput="if(isNaN(value)){value = null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+2)}"
                                placeholder="请输入每小时装卸点数"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="车辆的平均时速"
                            prop="aveSpeedValue"
                        >
                            <el-input
                                v-model.number="form.aveSpeedValue"
                                clearable
                                :disabled="
                                    type === 'check' || type === 'searchEdit'
                                "
                                maxlength="10"
                                oninput="if(isNaN(value)){value = null}"
                                placeholder="请输入车辆的平均时速"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-tooltip
                            :content="form.coverSiteNameListString"
                            effect="dark"
                            placement="top"
                        >
                            <el-form-item
                                label="覆盖服务平台"
                                prop="coverSiteNameListString"
                            >
                                <advance-dialog
                                    :disabled="
                                        !form.siteName ||
                                        type === 'check' ||
                                        type === 'searchEdit'
                                    "
                                    v-model="form.coverSiteNameListString"
                                    :mValue="form.coverSiteNameListString"
                                    :params="config.coverSiteParam"
                                    :cacheData="cacheData"
                                    @getAdvanceValue="getAdvanceValue"
                                >
                                </advance-dialog>
                            </el-form-item>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="可超方量">
                            <el-input
                                v-model.number="form.slackVolumeValue"
                                clearable
                                :disabled="
                                    type === 'check' || type === 'searchEdit'
                                "
                                maxlength="10"
                                oninput="if(isNaN(value)){value = null}"
                                placeholder="请输入可超方量"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="启用状态" prop="algorithmStatus">
                            <el-select
                                v-model="form.algorithmStatus"
                                placeholder="请选择状态"
                                :disabled="
                                    type === 'check' || type === 'searchEdit'
                                "
                            >
                                <el-option :value="0" label="启用"></el-option>
                                <el-option :value="1" label="停用"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div>
                <div class="detail">
                    <span class="tip">*</span>
                    <span class="detail-title">参与车型</span>
                    <el-button
                        v-if="type === 'add' || type === 'edit'"
                        type="primary"
                        @click="add"
                        >新增</el-button
                    >
                </div>
                <m-table
                    ref="table"
                    :tableConfig="config.table"
                    :tableData="form.baseAlgorithmParamCarsList"
                    :loading="tableLoading"
                    @del-btn="delBtn"
                >
                </m-table>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button
                v-has="'otp02050007'"
                v-if="type !== 'check'"
                type="primary"
                @click="handleSure"
                :loading="loading"
                >保 存</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import advanceDialog from '@/components/lots/otpAdvance';
import { addDate, getDetail, editDate, deleteCarByIds, getSearchDetail, getCarListApi } from '../../../../api/algorithmParameters';
import mTable from './EditTable';
import editDialogConfig from './editDialogConfig.js';
import config from './config.js';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    components: { advanceDialog, mTable },
    data () {
        return {
            siteName: '',
            siteCode: '',
            form: {
                id: '',
                siteCode: '',
                siteName: '',
                inDistanceValue: '',
                accValue: '',
                slackNValue: '',
                slackDValue: '',
                maxRouteTimeValue: '',
                efValue: '',
                aveSpeedValue: '',
                algorithmStatus: '',
                coverSiteCodeListString: '',
                coverSiteNameListString: '',
                baseAlgorithmParamCarsList: [],
                var2: '0',
                bigV2Value: '',
                bigMaxVolume2Value: '',
                var1: '0',
                bigV1Value: '',
                bigMaxVolume1Value: '',
                maxVolume: '',
                equipmentName: '',
                slackVolumeValue: ''

            },
            loading: false,
            config: this.type === 'searchEdit' ? config : editDialogConfig,
            loadings: false,
            tableLoading: false,
            cacheData: [],
            dic: {}// 数据字典返回值
        };
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '新增'
        },
        type: {
            type: String,
            default: 'add'
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    async created () {
        if (this.type !== 'add') {
            await this.getCarList();
        }
        if (this.rowData.id) {
            this.getDetail();
            if (this.type === 'check') {
                this.config.table.leftOperation = false;
            } else {
                this.config.table.leftOperation = true;
            }
        } else if (this.type !== 'searchEdit') {
            this.$nextTick(() => {
                this.$refs.table.addRow();
            });
        }
        this.getDictList();
    },
    methods: {
        getCarList () {
            const options = [];
            this.carOptions = {};
            const params = {
                queryType: 'ALL',
                siteCode: this.rowData.siteCode || this.form.siteCode
            };
            getCarListApi(params).then(res => {
                if (res && res.data.equipmentDictList) {
                    res.data.equipmentDictList.forEach(item => {
                        options.push({ label: item.equipmentName, value: item.equipmentType });
                        this.carOptions[item.equipmentType] = item.equipmentName;
                    });
                }
                this.config.table.columns[0].options = options;
            });
        },
        getAdvanceValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
        },
        // 获取服务平台数据
        getAdvanceSiteNameValue (data) {
            this.form = {
                ...this.form,
                ...data
            };
            this.form.coverSiteCodeListString = data.siteCode;
            this.form.coverSiteNameListString = data.siteName;
            this.getCarList();
        },
        getAdvance (data) {
            this.siteCode = data.siteCode;
            this.siteName = data.siteName;
        },
        handleSearch () {
            this.loadings = true;
            getSearchDetail({ siteCode: this.siteCode }).then(res => {
                if (res && +res.code === 0) {
                    if (res.data) {
                        this.form = Object.assign({}, res.data);
                        this.form.baseAlgorithmParamCarsList = this.form.baseAlgorithmParamCarsExtList;
                        this.form.baseAlgorithmParamCarsList.forEach(item => {
                            item.enableRestrictArea = item.enableRestrictArea.toString();
                        });
                    } else {
                        this.$message.warning('该服务平台数据不存在');
                    }
                }
            }).finally(() => {
                this.loadings = false;
            });
        },
        handleClose () {
            this.form = {};
            this.config.table.columns[0].options = [];
            this.$emit('handleClose');
        },
        // 获取数据字典
        async getDictList () {
            const res = await dictWithUrl('MAX_CAR_TYPE');
            if (!res || res.code !== '0') return;
            this.dic = res.data;
        },
        getDetail () {
            this.loadings = true;
            getDetail(this.rowData.id).then(res => {
                if (res && +res.code === 0) {
                    this.form = Object.assign({}, res.data);
                    this.form.baseAlgorithmParamCarsList = this.form.baseAlgorithmParamCarsExtList;
                    this.form.baseAlgorithmParamCarsList.forEach(item => {
                        item.enableRestrictArea = item.enableRestrictArea.toString();
                    });
                    this.loadings = false;
                }
            });
        },
        // 新增
        add () {
            this.$refs.table.addRow();
        },
        // 删除
        delBtn (row) {
            if (row.id) {
                this.tableLoading = true;
                deleteCarByIds(row.id).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除明细成功');
                    }
                }).finally(() => {
                    this.tableLoading = false;
                });
            }
        },
        // 保存
        handleSure () {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if (!this.form.baseAlgorithmParamCarsList.length) {
                        return this.$message.warning('至少添加一条车型');
                    }
                    // 表格数据必填校验
                    const msg = this.$refs.table.saveData();
                    if (!msg) {
                        return false;
                    }
                    // 车型唯一校验
                    const hash = {};
                    let arr = [];
                    arr = this.form.baseAlgorithmParamCarsList.reduce((item, next) => {
                        // eslint-disable-next-line
                        hash[next.equipmentType] ? '' : hash[next.equipmentType] = true && item.push(next);
                        return item;
                    }, []);
                    if (arr.length !== this.form.baseAlgorithmParamCarsList.length) {
                        return this.$message.warning('车型不能重复，请重新输入');
                    }
                    if (this.form.baseAlgorithmParamCarsList.some(item => {
                        return +item.minVolume > +item.maxVolume;
                    })) {
                        return this.$message.warning('存在装载下限大于装载上限的车型，请重新输入');
                    }
                    this.loading = true;
                    this.getName();
                    if (this.form.id) {
                        editDate(this.form, this.form.id).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('编辑成功');
                                this.form = {};
                                this.config.table.columns[0].options = [];
                                this.$emit('handleClose', true);
                            }
                        }).finally(() => {
                            this.loading = false;
                        });
                    } else {
                        addDate(this.form).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('新增成功');
                                this.form = {};
                                this.config.table.columns[0].options = [];
                                this.$emit('handleClose', true);
                            }
                        }).finally(() => {
                            this.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        getName () {
            if (this.form.baseAlgorithmParamCarsList.length) {
                this.form.baseAlgorithmParamCarsList.forEach(item => {
                    item.equipmentName = this.carOptions[item.equipmentType] || '';
                });
            }
        }
    },
    watch: {
        'form.coverSiteCodeListString': {
            handler (newVal, oldVal) {
                this.cacheData = [];
                newVal.split(',').forEach(item => {
                    if (item) {
                        this.cacheData.push({
                            escoCompanyNo: item
                        });
                    }
                });
                const coverSiteNameListString = this.form.coverSiteNameListString.split(',');
                this.cacheData.forEach((item, index) => {
                    item.escoCompanyNameCn = coverSiteNameListString[index];
                });
            },
            deep: true,
            immediate: true
        }
    }
};
</script>
<style lang="less">
.algorithm-parameters {
    .algorithm-from {
        .el-form-item__content .el-input-group {
            vertical-align: middle;
        }
        .el-date-editor--datetimerange.el-input__inner,
        .el-select {
            width: 100%;
        }
        .el-form-item__label,
        .el-form-item__content {
            line-height: 20px;
        }
        .el-form-item {
            margin-bottom: 20px;
        }
    }
    .detail {
        border-top: 1px solid #ccc;
        padding-top: 10px;
        margin-bottom: 10px;
        .tip {
            color: red;
            font-size: 16px;
            margin-right: 4px;
        }
        .detail-title {
            font-size: 16px;
            margin-right: 20px;
            font-weight: 550;
        }
    }
    .search-title {
        padding-left: 10px;
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid #ccc;
    }
}
</style>
